import { SxProps, Theme } from '@mui/material';

export const snackbarStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  padding: '6px 16px 6px 8px',
  borderRadius: '6px',
  backgroundColor: '#e0edd7',
  fontSize: '14px',
  fontWeight: '400',
  color: 'customColors.blue.950',
  '.MuiAlert-action': {
    display: 'none',
  },
  '.MuiAlert-icon': {
    padding: 0,
    marginRight: '8px',
  },
  '.MuiAlert-icon:hover': {
    cursor: 'pointer',
  },
  '.MuiAlert-message': {
    padding: 0,
  },
  '&.MuiAlert-colorError': {
    color: 'white',
    backgroundColor: 'error.main',
    '.MuiAlert-icon path': {
      stroke: 'white',
    },
  },
};
